/*!
 * sd24-forms.js — AJAX-Submission fuer sd24-form Sections
 *
 * Features:
 * - Client-seitige Basisvalidierung (HTML5 + data-required, maxMB)
 * - Drag-&-Drop-Upload mit Preview, Entfernen, Multi-File
 * - XHR mit Upload-Progress
 * - JSON-Response vom PHP-Endpoint wird ausgewertet
 * - Feldspezifische Fehlermeldungen (response.fields[])
 * - Erfolg: Inline-Meldung oder Redirect auf success_url
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function cssEsc(s)     { return String(s).replace(/(["\\])/g, '\\$1'); }

  function formatBytes(bytes) {
    if (!bytes && bytes !== 0) return '';
    var units = ['B', 'KB', 'MB', 'GB'];
    var i = 0;
    var v = bytes;
    while (v >= 1024 && i < units.length - 1) { v /= 1024; i++; }
    return (i === 0 ? v : v.toFixed(1)) + ' ' + units[i];
  }

  function getMessages(form) {
    return {
      sending:        form.getAttribute('data-msg-sending')         || 'Wird gesendet…',
      success:        form.getAttribute('data-msg-success')         || 'Vielen Dank für Ihre Anfrage!',
      error:          form.getAttribute('data-msg-error')           || 'Leider ist ein Fehler aufgetreten.',
      required:       form.getAttribute('data-msg-required')        || 'Pflichtfeld.',
      file_too_large: form.getAttribute('data-msg-file-too-large')  || 'Datei ist zu groß.',
      too_many_files: form.getAttribute('data-msg-too-many-files')  || 'Zu viele Dateien.',
      file_type:      form.getAttribute('data-msg-file-type')       || 'Dateityp nicht erlaubt.',
      remove_file:    form.getAttribute('data-msg-remove-file')     || 'Entfernen',
      drop_hint:      form.getAttribute('data-msg-drop-hint')       || 'Dateien ablegen'
    };
  }

  // ---------------------------------------------------------------
  // Status / Errors
  // ---------------------------------------------------------------
  function setStatus(form, state, text) {
    var box = qs('[data-sd24-status]', form);
    if (!box) return;
    if (!state) { box.removeAttribute('data-state'); box.textContent = ''; return; }
    box.setAttribute('data-state', state);
    box.textContent = text || '';
  }

  function clearErrors(form) {
    qsa('.sd24-form__error', form).forEach(function (el) { el.textContent = ''; });
    qsa('.sd24-form__field.is-invalid', form).forEach(function (el) { el.classList.remove('is-invalid'); });
  }

  function showFieldError(form, fieldName, message) {
    var err = qs('[data-error-for="' + cssEsc(fieldName) + '"]', form);
    if (err) err.textContent = message || '';
    var input = qs('[name="' + cssEsc(fieldName) + '"], [name="' + cssEsc(fieldName) + '[]"]', form);
    if (input) {
      var field = input.closest('.sd24-form__field');
      if (field) field.classList.add('is-invalid');
    }
  }

  // ---------------------------------------------------------------
  // Drop-Zone
  // ---------------------------------------------------------------
  // Eigene File-Verwaltung, weil ein <input type="file"> sich im
  // Browser nur per DataTransfer neu befuellen laesst.
  //
  // Pro Dropzone-Element halten wir eine Liste von File-Objekten;
  // beim Change-Event werden sie in ein DataTransfer geschrieben
  // und dem Input zugewiesen.
  // ---------------------------------------------------------------
  function initDropzone(zone, form) {
    var input   = qs('[data-sd24-dropzone-input]', zone);
    var area    = qs('[data-sd24-dropzone-area]', zone);
    var listEl  = qs('[data-sd24-dropzone-list]', zone);
    if (!input || !area || !listEl) return;

    var msgs     = getMessages(form);
    var maxFiles = parseInt(zone.getAttribute('data-max-files') || '5', 10);
    var maxMB    = parseFloat(zone.getAttribute('data-max-mb')  || '0');
    var accept   = (input.getAttribute('accept') || '').toLowerCase();
    var field    = zone.getAttribute('data-field-name') || input.name.replace(/\[\]$/, '');

    zone._files = [];

    // Accept-Check (MIME + Extension)
    function matchesAccept(file) {
      if (!accept) return true;
      var types = accept.split(',').map(function (s) { return s.trim().toLowerCase(); });
      var mime  = (file.type || '').toLowerCase();
      var name  = (file.name || '').toLowerCase();
      for (var i = 0; i < types.length; i++) {
        var t = types[i];
        if (!t) continue;
        if (t.charAt(0) === '.') {
          if (name.slice(-t.length) === t) return true;
        } else if (t.indexOf('/*') === t.length - 2) {
          var prefix = t.slice(0, -1); // "image/"
          if (mime.indexOf(prefix) === 0) return true;
        } else if (t === mime) {
          return true;
        }
      }
      return false;
    }

    function addFiles(fileList) {
      var added   = 0;
      var rejected = null;
      var arr = Array.prototype.slice.call(fileList);

      for (var i = 0; i < arr.length; i++) {
        var f = arr[i];

        if (zone._files.length >= maxFiles) {
          rejected = msgs.too_many_files.replace('%max%', String(maxFiles));
          break;
        }
        if (!matchesAccept(f)) {
          rejected = msgs.file_type;
          continue;
        }
        if (maxMB > 0 && f.size > maxMB * 1024 * 1024) {
          rejected = msgs.file_too_large + ' (' + f.name + ', max. ' + maxMB + ' MB)';
          continue;
        }
        // Duplikat-Check (Name+Size)
        var isDup = false;
        for (var j = 0; j < zone._files.length; j++) {
          if (zone._files[j].name === f.name && zone._files[j].size === f.size) { isDup = true; break; }
        }
        if (isDup) continue;

        zone._files.push(f);
        added++;
      }

      syncInput();
      renderList();

      var err = qs('[data-error-for="' + cssEsc(field) + '"]', form);
      if (err) err.textContent = rejected || '';
      if (rejected) zone.classList.add('is-invalid'); else zone.classList.remove('is-invalid');
    }

    function removeFile(idx) {
      zone._files.splice(idx, 1);
      syncInput();
      renderList();
      var err = qs('[data-error-for="' + cssEsc(field) + '"]', form);
      if (err) err.textContent = '';
      zone.classList.remove('is-invalid');
    }

    function syncInput() {
      // DataTransfer wird in modernen Browsern unterstuetzt (Chrome/Firefox/Safari).
      try {
        var dt = new DataTransfer();
        zone._files.forEach(function (f) { dt.items.add(f); });
        input.files = dt.files;
      } catch (e) {
        // Fallback: Input-Wert einfach unveraendert lassen.
      }
      zone.setAttribute('data-count', String(zone._files.length));
    }

    function renderList() {
      listEl.innerHTML = '';
      if (!zone._files.length) { zone.classList.remove('has-files'); return; }
      zone.classList.add('has-files');

      zone._files.forEach(function (f, idx) {
        var li = document.createElement('li');
        li.className = 'sd24-form__dropzone-item';

        var thumb = document.createElement('span');
        thumb.className = 'sd24-form__dropzone-thumb';

        if (f.type && f.type.indexOf('image/') === 0) {
          var img = document.createElement('img');
          img.alt = f.name;
          img.loading = 'lazy';
          var url = URL.createObjectURL(f);
          img.src = url;
          img.onload = function () { setTimeout(function () { URL.revokeObjectURL(url); }, 2000); };
          thumb.appendChild(img);
        } else if (f.type && f.type.indexOf('video/') === 0) {
          thumb.textContent = '▶';
          thumb.classList.add('is-video');
        } else {
          thumb.textContent = '📄';
          thumb.classList.add('is-doc');
        }

        var meta = document.createElement('span');
        meta.className = 'sd24-form__dropzone-meta';
        var name = document.createElement('strong');
        name.className = 'sd24-form__dropzone-filename';
        name.textContent = f.name;
        var size = document.createElement('span');
        size.className = 'sd24-form__dropzone-filesize';
        size.textContent = formatBytes(f.size);
        meta.appendChild(name);
        meta.appendChild(size);

        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'sd24-form__dropzone-remove';
        rm.setAttribute('aria-label', msgs.remove_file);
        rm.title = msgs.remove_file;
        rm.innerHTML = '&times;';
        rm.addEventListener('click', function () { removeFile(idx); });

        li.appendChild(thumb);
        li.appendChild(meta);
        li.appendChild(rm);
        listEl.appendChild(li);
      });
    }

    // Native File-Input: bei Auswahl via Dialog werden die Files
    // als Delta in unsere Liste uebernommen (nicht ersetzt), damit
    // man in zwei Durchgaengen auswaehlen kann.
    input.addEventListener('change', function () {
      if (!input.files || !input.files.length) return;
      var picked = input.files;
      // Clearen, damit wir bei syncInput wieder aufbauen
      addFiles(picked);
    });

    // Dragover-Feedback
    ['dragenter', 'dragover'].forEach(function (ev) {
      area.addEventListener(ev, function (e) {
        e.preventDefault();
        e.stopPropagation();
        zone.classList.add('is-dragover');
      });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      area.addEventListener(ev, function (e) {
        e.preventDefault();
        e.stopPropagation();
        zone.classList.remove('is-dragover');
      });
    });
    area.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
        addFiles(e.dataTransfer.files);
      }
    });

    // Tastaturbedienung
    area.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        input.click();
      }
    });
  }

  // ---------------------------------------------------------------
  // Validierung
  // ---------------------------------------------------------------
  function validate(form, messages) {
    clearErrors(form);
    var ok = true;

    qsa('[data-required="1"]', form).forEach(function (input) {
      if (input.type === 'file') {
        var zone = input.closest('[data-sd24-dropzone]');
        var count = zone && zone._files ? zone._files.length : (input.files ? input.files.length : 0);
        if (count < 1) { ok = false; showFieldError(form, input.name.replace(/\[\]$/, ''), messages.required); }
        return;
      }
      var val = (input.type === 'checkbox' || input.type === 'radio')
        ? (form.querySelectorAll('[name="' + cssEsc(input.name) + '"]:checked').length > 0)
        : (input.value || '').trim() !== '';
      if (!val) {
        ok = false;
        showFieldError(form, input.name, messages.required);
      }
    });

    qsa('input[type="email"]', form).forEach(function (input) {
      var v = (input.value || '').trim();
      if (v !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
        ok = false;
        showFieldError(form, input.name, messages.email_invalid || 'Bitte gültige E-Mail-Adresse eingeben.');
      }
    });

    // Max-MB/Max-Count fuer Dropzones
    qsa('[data-sd24-dropzone]', form).forEach(function (zone) {
      if (!zone._files) return;
      var maxFiles = parseInt(zone.getAttribute('data-max-files') || '0', 10);
      var maxMB    = parseFloat(zone.getAttribute('data-max-mb')  || '0');
      var field    = zone.getAttribute('data-field-name') || '';
      if (maxFiles > 0 && zone._files.length > maxFiles) {
        ok = false; showFieldError(form, field, messages.too_many_files.replace('%max%', String(maxFiles)));
      }
      if (maxMB > 0) {
        var limit = maxMB * 1024 * 1024;
        for (var i = 0; i < zone._files.length; i++) {
          if (zone._files[i].size > limit) {
            ok = false;
            showFieldError(form, field, messages.file_too_large + ' (' + zone._files[i].name + ', max. ' + maxMB + ' MB)');
            break;
          }
        }
      }
    });

    return ok;
  }

  // ---------------------------------------------------------------
  // Submit
  // ---------------------------------------------------------------
  function setSubmitting(form, submitting) {
    var btn = qs('.sd24-form__submit', form);
    if (!btn) return;
    btn.disabled = !!submitting;
    if (submitting) btn.setAttribute('data-loading', '1');
    else btn.removeAttribute('data-loading');
  }

  function setProgress(form, pct) {
    var wrap = qs('.sd24-form__progress', form);
    var bar  = qs('.sd24-form__progress-bar', form);
    var lbl  = qs('.sd24-form__progress-label', form);
    if (!wrap || !bar) return;
    if (pct == null) {
      wrap.removeAttribute('data-visible');
      bar.style.setProperty('--progress', '0%');
      if (lbl) lbl.textContent = '0 %';
      return;
    }
    wrap.setAttribute('data-visible', '1');
    bar.style.setProperty('--progress', pct + '%');
    if (lbl) lbl.textContent = Math.round(pct) + ' %';
  }

  function submit(form) {
    var endpoint = form.getAttribute('data-endpoint');
    if (!endpoint) {
      setStatus(form, 'error', 'Kein API-Endpoint konfiguriert.');
      return;
    }

    var messages = getMessages(form);

    if (!validate(form, messages)) {
      setStatus(form, 'error', messages.required);
      return;
    }

    var data = new FormData(form);
    var xhr = new XMLHttpRequest();
    xhr.open('POST', endpoint, true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.setRequestHeader('Accept', 'application/json');

    xhr.upload.addEventListener('progress', function (e) {
      if (e.lengthComputable) setProgress(form, (e.loaded / e.total) * 100);
    });

    xhr.onloadstart = function () {
      setSubmitting(form, true);
      setStatus(form, null);
      setProgress(form, 0);
    };

    xhr.onerror = function () {
      setSubmitting(form, false);
      setProgress(form, null);
      setStatus(form, 'error', messages.error);
    };

    xhr.onload = function () {
      setSubmitting(form, false);
      setProgress(form, null);

      var res = null;
      try { res = JSON.parse(xhr.responseText); } catch (e) { /* noop */ }

      if (xhr.status >= 200 && xhr.status < 300 && res && res.ok) {
        var successUrl = form.getAttribute('data-success-url');
        if (successUrl) { window.location.href = successUrl; return; }
        setStatus(form, 'success', (res && res.message) || messages.success);
        form.reset();
        // Dropzones ebenfalls leeren
        qsa('[data-sd24-dropzone]', form).forEach(function (zone) {
          zone._files = [];
          var listEl = qs('[data-sd24-dropzone-list]', zone);
          if (listEl) listEl.innerHTML = '';
          zone.classList.remove('has-files');
          zone.removeAttribute('data-count');
        });
        var status = qs('[data-sd24-status]', form);
        if (status && status.scrollIntoView) status.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (res && Array.isArray(res.fields) && res.fields.length) {
        res.fields.forEach(function (f) {
          var parts = String(f).split(':');
          showFieldError(form, parts[0], (res.message || messages.error));
        });
      }
      setStatus(form, 'error', (res && res.message) || messages.error);
    };

    xhr.send(data);
  }

  // ---------------------------------------------------------------
  // Init
  // ---------------------------------------------------------------
  ready(function () {
    qsa('form[data-sd24-form]').forEach(function (form) {
      qsa('[data-sd24-dropzone]', form).forEach(function (zone) { initDropzone(zone, form); });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        submit(form);
      });
    });
  });
})();
